import SectionCard from "@/components/base/SectionCard";
import Stars from "@/components/base/Stars";
import type { CategoryShare, RatingBucket } from "@/types";
import { formatNumber } from "@/utils/format";

interface RatingsBreakdownProps {
  buckets: RatingBucket[];
  average: number;
  total: number;
}

export function RatingsBreakdown({
  buckets,
  average,
  total,
}: RatingsBreakdownProps) {
  return (
    <SectionCard
      title="تقييمات العملاء"
      subtitle={`${formatNumber(total)} تقييم`}
      icon="ri-star-line"
      iconClass="bg-accent-100 text-accent-800"
    >
      <div className="flex items-center gap-4 rounded-box bg-background-50 px-4 py-4">
        <div className="text-center">
          <p className="text-3xl font-bold text-foreground-950">{average}</p>
          <Stars value={average} size="text-sm" />
        </div>
        <div className="flex-1">
          <ul className="space-y-1.5">
            {buckets.map((bucket) => (
              <li key={bucket.stars} className="flex items-center gap-2">
                <span className="w-9 text-xs text-foreground-500 whitespace-nowrap">
                  {bucket.stars} نجوم
                </span>
                <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${(bucket.count / total) * 100}%` }}
                  ></div>
                </div>
                <span className="w-8 text-end text-xs text-foreground-500">
                  {bucket.count}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </SectionCard>
  );
}

interface CategoryShareCardProps {
  shares: CategoryShare[];
}

export function CategoryShareCard({ shares }: CategoryShareCardProps) {
  return (
    <SectionCard
      title="توزيع المبيعات حسب التصنيف"
      subtitle="نسبة كل تصنيف من إجمالي المبيعات"
      icon="ri-pie-chart-2-line"
      iconClass="bg-secondary-200 text-secondary-800"
    >
      <ul className="space-y-4">
        {shares.map((share) => (
          <li key={share.name}>
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium text-foreground-800">
                {share.name}
              </span>
              <span className="font-bold text-foreground-950">
                {share.percent}%
              </span>
            </div>
            <div className="mt-2 h-2 rounded-full bg-background-100 overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{ width: `${share.percent}%`, backgroundColor: share.color }}
              ></div>
            </div>
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}